/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ContainerFindingsResponse extends models.SecurityFinding {
    getFixupPrototypeFunction() { return ContainerFindingsResponse.fixupPrototype; }

    static newInstance(model: Partial<ContainerFindingsResponse>): ContainerFindingsResponse {
        let obj = Object.assign(new ContainerFindingsResponse(), model);
        ContainerFindingsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ContainerFindingsResponse>): ContainerFindingsResponse {
        if (!model) return null;
        return ContainerFindingsResponse.newInstance(<ContainerFindingsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ContainerFindingsResponse) {
        if (!obj) return;

        models.ContainerFindingsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ContainerFindingsResponse): boolean {
        if (models.SecurityFinding.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ContainerFindingsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * SBOM version ID to which the findings are associated
     */
    sbom_version_id: string;

    /**
     * Unique code identifying the specific finding
     */
    code: string;

    /**
     * Identifies the subject of the scan, can be either Image or Dockerfile
     */
    target: string;

    /**
     * Tenant ID to which the findings are associated
     */
    tenant_id: string;

}
